import script from "./Capital.vue?vue&type=script&setup=true&lang=js"
export * from "./Capital.vue?vue&type=script&setup=true&lang=js"

import "./Capital.vue?vue&type=style&index=0&id=c8a96de4&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8a96de4"]])

export default __exports__